import { render, staticRenderFns } from "./platform_viewCourse.vue?vue&type=template&id=3ef43753&scoped=true&"
import script from "./platform_viewCourse.vue?vue&type=script&lang=js&"
export * from "./platform_viewCourse.vue?vue&type=script&lang=js&"
import style0 from "./platform_viewCourse.vue?vue&type=style&index=0&id=3ef43753&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef43753",
  null
  
)

export default component.exports